import { useTheme } from "@emotion/react";
import { Box, Container, Grid, Typography } from "@mui/material";
import logo from "../assets/logo.svg";
import { Link } from "react-router-dom";
// import call from "../assets/icon/call-calling.png";
// import whatsapp from "../assets/icon/whatsapp.png";
import location from "../assets/icon/location-add.png";
import fingerprint from "../assets/fingerprint.png";
// import GetYourId from "./contact_us/GetYourId";
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles((theme) => ({
  top_wrapper: {
    background: `url(${fingerprint}), #e7fffd`,
    backgroundPosition: "bottom left",
    backgroundRepeat: "no-repeat",
    width: "100%",
    maxWidth: "2200px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  wrapper: {
    padding: "30px 0px 56px  0px",
  },
  right: { flex: 1, display: "flex", justifyContent: "flex-end" },
  link_wrapper: { display: "flex", flexDirection: "column", gap: "20px" },
  link_title: {
    color: "#555",
    textDecoration: "none",
  },
  link: { color: "#555", textDecoration: "none" },
  link_right: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    textDecoration: "none",
  },
  link_contact: {
    color: "#016363",
    fontWeight: "500 !important",
  },
  link2: {
    color: "#016363",
    fontWeight: 400,
  },
  bottom_wrapper: {
    display: "flex",
    justifyContent: "space-between",
    borderTop: `1px solid #d5f9ff`,
    // marginBottom: -20,
  },
  bottom: {
    display: "flex",
    gap: 40,
  },
  bottom_link_style: {
    textDecoration: "none",
    color: "#222",
  },
}));
const WebsiteFooter = () => {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <Box className={classes.top_wrapper}>
      {/* <Box className={classes.wrapper}>
        <Container maxWidth="xl">
          <Grid container spacing={5}>
            <Grid item md={3} xs={12}>
              <img src={logo} alt="" />
              <Typography variant="body2" sx={{ mt: 1 }}>
                VerifyMe - an advanced e-KYC solution designed to streamline and
                simplify the customer verification process. It utilizes
                cutting-edge technology <Link to="#">.... Read More</Link>
              </Typography>
            </Grid>

            <Grid item md={3} xs={12}>
              <Box className={classes.link_wrapper}>
                <Typography variant="subtitle2" className={classes.link_title}>
                  About
                </Typography>
                <Link
                  to={`${process.env.REACT_APP_WEBSITE_URL}/#services`}
                  className={classes.link}
                >
                  <Typography variant="body1" className={classes.link}>
                    At a Glance
                  </Typography>
                </Link>
                <Link to="/#how_it_works" className={classes.link}>
                  <Typography variant="body1" className={classes.link}>
                    How it Works?
                  </Typography>
                </Link>

                <Link to="/#developers" className={classes.link}>
                  <Typography variant="body1" className={classes.link}>
                    Developers
                  </Typography>
                </Link>
                <Link to="/contact-us" className={classes.link}>
                  <Typography variant="body1" className={classes.link}>
                    Contact Us
                  </Typography>
                </Link>
              </Box>
            </Grid>
            <Grid item md={3} xs={12}>
              <Box className={classes.link_wrapper}>
                <Typography variant="subtitle2" className={classes.link_title}>
                  FAQ
                </Typography>
                <Link to="/login" className={classes.link}>
                  <Typography variant="body1" className={classes.link}>
                    Account
                  </Typography>
                </Link>
                <Box className={classes.link}>
                  <GetYourId title="Request a demo" type="demo" />
                </Box>
                <Link to="/#anywhere" className={classes.link}>
                  <Typography variant="body1" className={classes.link}>
                    Documentation
                  </Typography>
                </Link>
                <Link to="/#services" className={classes.link}>
                  <Typography variant="body1" className={classes.link}>
                    Services
                  </Typography>
                </Link>
                <Link to="/pricing" className={classes.link}>
                  <Typography variant="body1" className={classes.link}>
                    Pricing
                  </Typography>
                </Link>
              </Box>
            </Grid>

            <Grid item md={3} xs={12}>
              <Box className={classes.link_wrapper}>
                <Typography variant="subtitle2" className={classes.link_title}>
                  Contact
                </Typography>
                
                <Link to="#" className={classes.link_right}>
                  <img src={location} alt="" />
                  <Box>
                    <Typography variant="body2" className={classes.link2}>
                      Mail
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.link_contact}
                    >
                      info@verifyme.global
                    </Typography>
                  </Box>
                </Link>
                <Typography variant="body1">
                  We appreciate you for going through our service elaborations.
                  If you have nay plans or query reach us anytime. We are open
                  24x7.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box> */}

      <Box
        className={classes.bottom_wrapper}
        sx={{
          flexDirection: {
            md: "row",
            xs: "column",
          },
          padding: { md: "24px 100px", xs: "24px 20px" },

          // textAlign: { xs: "center" },
        }}
      >
        <Box
          //  className={classes.bottom}
          sx={{
            display: "flex",
            gap: { md: "40px", xs: "10px" },
            flexDirection: { md: "row", xs: "column" },
          }}
        >
          <Link
            to={`${process.env.REACT_APP_WEBSITE_URL}/privacy-policy`}
            className={classes.bottom_link_style}
          >
            <Typography variant="body1">Privacy policy</Typography>
          </Link>
          <Link
            to={`${process.env.REACT_APP_WEBSITE_URL}/sitemap`}
            className={classes.bottom_link_style}
          >
            <Typography variant="body1">Sitemap</Typography>
          </Link>
          <Link
            to={`${process.env.REACT_APP_WEBSITE_URL}/terms-of-use`}
            className={classes.bottom_link_style}
          >
            <Typography variant="body1">Terms of Use</Typography>
          </Link>
        </Box>
        <Box sx={{ paddingTop: { xs: 2, md: 0 } }}>
          <Typography variant="body1">
            © {new Date().getFullYear()}, All Rights Reserved
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default WebsiteFooter;
